/* tslint:disable:indent */
import {EventEmitter, Injectable} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {Avis} from 'src/app/models/avis';
import {FormsEnum} from 'src/app/models/enums/forms.enum';
import {JsonContentEnum} from 'src/app/models/enums/json-content.enum';
import {Endpoints} from '../../../models/endpoints';
import {StatutFluxEnum} from '../../../models/enums/statut-flux.enum';
import {Flux} from '../../../models/flux';
import {StepperBuilderService} from '../../avisDePub/creer/services/stepper.builder.service';
import {Constants} from '../../shared/generic/models/constants';
import {FormExtractorService} from '../../shared/services/form-extractor.service';
import {HttpService} from '../../shared/services/http.service';
import {LogService} from '../../shared/services/log.service';
import {FormADExtractorService} from '../adapte/services/formad-extractor.service';
import {FacturationResponse} from '../common/models/facturationResponse';
import {FacturationApiService} from './facturation.api.service';
import {FormulaireExtractorDispatcherService} from './formulaire-extractor-dispatcher.service';
import {AutoCompleteService} from '../../shared/services/auto-complete.service';
import {CanNavigateInStepperService} from '../../shared/services/can-navigate-in-stepper.service';
import {EformsExtractorService} from '../eforms/services/eforms-extractor.service';
import {SessionService} from '../../administration/services/session.service';
import moment from 'moment';
import {AvisDataTransferService} from '../../shared/services/avis-data-transfer.service';
import {IdWebApiService} from './idweb.api.service';
import {Champ} from '../common/models/champ';
import {EformDataService} from "../eforms/services/eform-data.service";
import {DuplicableElementPartialPathsEnum} from "../eforms/enum/duplicable-element-partial-paths.enum";
import {DuplicableElementIdPartEnum} from "../eforms/enum/duplicable-element-id-part.enum";
import {DuplicableElementSubSectionIdEnum} from "../eforms/enum/duplicable-element-sub-section-id.enum";
import { DuplicableObjectArrayEnum } from '../eforms/enum/duplicable-object-array.enum';

@Injectable({
  providedIn: 'root',
})
export class FormulaireServiceService {
  private LOG: LogService = new LogService(FormulaireServiceService);
  formulaireResponse: EventEmitter<FacturationResponse> = new EventEmitter();
  sub: Map<string, Subscription[]> = new Map<string, Subscription[]>();
  eformErrors: any[] = [];
  public isValidObs = new BehaviorSubject<boolean>(false);
  public actualFormIdAnnEmetteur = new BehaviorSubject(null);
  public actualFormContractFolderId = new BehaviorSubject(null);
  public idParentFluxBoampEform = new BehaviorSubject(null);

  public formulaireAdapte = false;

  constructor(
    private http: HttpService,
    private stepperBuilderService: StepperBuilderService,
    private translate: TranslateService,
    private formulaireExtractorDispatcherService: FormulaireExtractorDispatcherService,
    private session: SessionService,
    private formExtractorService: FormExtractorService,
    private formADExtractorService: FormADExtractorService,
    public facturationApiService: FacturationApiService,
    public idWebApiService: IdWebApiService,
    private autoCompleteService: AutoCompleteService,
    private canNavigateInStepperService: CanNavigateInStepperService,
    private eformsExtractorService: EformsExtractorService,
    private avisDataTransferService: AvisDataTransferService,
    private eformDataService: EformDataService
  ) {
  }

  public create(avis: Avis, referenceAvisParent = null, isPreremplissage): Observable<Avis> {
    return this.http
      .post(Endpoints.AVIS_CREATE + Endpoints.IS_PREREMPLISSAGE + isPreremplissage + (referenceAvisParent ? Endpoints.GET_ONE_PARAM4 + referenceAvisParent : ''), avis, Avis);

  }

  public update(avis: Avis, referenceAvisParent = null): Observable<any> {
    return this.http
      .put(Endpoints.AVIS_UPDATE + (referenceAvisParent ? Endpoints.REFERENCE_AVIS_PARENT + referenceAvisParent : ''), avis, Boolean);
  }

  public findLinkables(avis: Avis, isMod2 = false): Observable<FormsEnum[]> {
    return this.http.get<FormsEnum[], FormsEnum>(Endpoints.FIND_LINKABLES + avis.formulaire.code + "&isMod2=" + isMod2);
  }

  public compare(avis: Avis) {
    if (avis == null) {
      return;
    }
    this.http
      .post(
        Endpoints.COMPARE_WITH_VALID +
        Endpoints.COMPARE_WITH_VALID_PARAM1 +
        avis.formulaire.code +
        Endpoints.COMPARE_WITH_VALID_PARAM2 +
        JsonContentEnum[JsonContentEnum.VALID],
        avis
        , Boolean)
      .subscribe(
        (data) => {
          return data;
        },
        (error) => {
          this.LOG.error('[OBJECTS ARE NOT compatible]');
          this.LOG.debug('error!!', error);
          return false;
        }
      );
  }

  public getAvis(
    referenceAvis: string,
    path: FormsEnum,
    jsonType: JsonContentEnum,
    referenceAvisParent: string,
    QANumber?: string
  ): Observable<Avis> {
    const redirectionContextId = sessionStorage.getItem('redirectionContextSessionService_redirectionContextId');
    if (JsonContentEnum[jsonType] === JsonContentEnum[JsonContentEnum.EMPTY] && !referenceAvis && !referenceAvisParent && redirectionContextId == null) {
      return this.http.get('assets/data/empty_forms/' + FormsEnum[path] + '.json', null, {basePath: ''});
    } else {
      return this.http.get(
        Endpoints.GET_ONE +
        Endpoints.GET_ONE_PARAM1 +
        referenceAvis +
        Endpoints.GET_ONE_PARAM2 +
        FormsEnum[path] +
        Endpoints.GET_ONE_PARAM3 +
        JsonContentEnum[jsonType] +
        ((referenceAvisParent) ? (
          Endpoints.GET_ONE_PARAM4 +
          referenceAvisParent
        ) : '') +
        ((QANumber != null) ? (
          Endpoints.GET_ONE_PARAM5 +
          QANumber
        ) : '')
        , Avis);
    }
  }

  private isPathCorrespondingToDuplicableObject(path: string): boolean {
    let isDuplicableObject = false;

    // Supprimer les index [0], [1], [2]... pour comparer uniquement les noms des éléments
    let cleanedPath = path.replace(/\[\d+\]/g, "");

    for (let pathOfDuplicableObject of Object.values(DuplicableElementPartialPathsEnum)) {
      if (cleanedPath.includes(pathOfDuplicableObject)) {
        isDuplicableObject = true;
        break;
      }
    }

    return isDuplicableObject;
  }

  /**
   * Détecte si un fieldId correspond à un objet duplicable via son suffixe
   * Ex: BT-773-Tender -> LotTender, BT-3202-Contract -> SettledContract
   * @param fieldId L'ID du champ (ex: BT-773-Tender)
   * @param location Le path JSON pour vérification supplémentaire
   * @private
   */
  private isDuplicableObjectFromFieldId(fieldId: string, location: string): boolean {
    if (!fieldId) return false;

    // Extraire le suffixe après le dernier tiret
    const parts = fieldId.split('-');
    if (parts.length < 2) return false;

    const suffix = parts[parts.length - 1];

    // Mapper les suffixes aux types d'objets duplicables
    const duplicableTypes = [
      { suffix: 'Tender', path: 'LotTender' },
      { suffix: 'Contract', path: 'SettledContract' },
      { suffix: 'Tenderer', path: 'TenderingParty' },
      { suffix: 'LotResult', path: 'LotResult' },
      { suffix: 'Organization', path: 'Organization' },
      { suffix: 'Lot', path: 'ProcurementProjectLot' }
    ];

    for (const type of duplicableTypes) {
      if (suffix === type.suffix) {
        // Vérifier que le location contient au moins NoticeResult ou Organizations ou ProcurementProjectLot
        if (location.includes('NoticeResult') || location.includes('Organizations') || location.includes('ProcurementProjectLot')) {
          return true;
        }
      }
    }

    return false;
  }

  /**
   * Vérification de la validité des champs
   * @param controls FormControls du formulaire
   * @returns valeur boolean selon validité des champs
   */
  public isFormValid(form, stepId, exportXml, onFinish: () => void) {
    this.sub.forEach(s => s.forEach(s2 => s2.unsubscribe()));
    this.sub = new Map<string, Subscription[]>();
    let subFlag = 1;
    if (this.canNavigateInStepperService.currentFormulaire?.includes('E_FORM_')) {
      this.stepperBuilderService.clearAllStepFieldsOnErrors();
      this.stepperBuilderService.clearAllStepFieldsOnWarnings();
    } else {
      this.stepperBuilderService.clearStepFieldsOnWarnings('_STEP_ID_' + stepId);
      this.stepperBuilderService.clearStepFieldsOnWarnings('_STEP_ID_SepSep_TypeFacturation');
      this.stepperBuilderService.clearStepFieldsOnWarnings('_STEP_ID_SepSep_TypeIndexation');
      this.stepperBuilderService.clearStepFieldsOnWarnings('_STEP_ID_SepSep_idAnnonceur');
      this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_' + stepId);
      this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_SepSep_TypeFacturation');
      this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_SepSep_TypeIndexation');
      this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_SepSep_idAnnonceur');
    }
    this.stepperBuilderService.eformSchematronsErrors = [];
    const stepStats = new Map<string, boolean>();
    let isValid = true;
    const controls: Map<string, AbstractControl> = form.controls;
    const regex = /(\w*)((_STEP_ID_\d+(\.\d+)?)|(_COMMON_ID_\d+(\.\d+)?))(\w*)/;
    Object.entries(controls).forEach((controlEntry) => {
      const formControlName = controlEntry[0];
      let formControl = controlEntry[1];
      if (formControlName.includes('CTRL_')) {
        if (formControlName.includes('CTRL_FACTURATION')) {
          const s = this.facturationApiService.facturationResponse.subscribe(next => {
            if (formControl.value.ctrlValidation) {
              const regEx = /(\w*)((_STEP_ID_\d+(\.\d+)?)|(_COMMON_ID_\d+(\.\d+)?))(\w*)/;
              let stepName = formControlName.replace(regEx, '$2');
              if (formControlName.includes('_TypeFacturation')) {
                stepName = "_STEP_ID_SepSep_TypeFacturation";
              } else if (formControlName.includes('_TypeIndexation')) {
                stepName = "_STEP_ID_SepSep_TypeIndexation";
              } else if (formControlName.includes('_SepSep_idAnnonceur')) {
                stepName = "_STEP_ID_SepSep_idAnnonceur";
              }
              stepStats.set(stepName, false);
              this.stepperBuilderService.addStepFieldsOnErrors(stepName, formControlName, formControl.value.validation_message);
              isValid = false;
            }
            if (formControl.value.ctrlValidationWarning) {
              const regEx = /(\w*)((_STEP_ID_\d+(\.\d+)?)|(_COMMON_ID_\d+(\.\d+)?))(\w*)/;
              let stepName = formControlName.replace(regEx, '$2');
              if (formControlName.includes('_TypeFacturation')) {
                stepName = "_STEP_ID_SepSep_TypeFacturation";
              } else if (formControlName.includes('_TypeIndexation')) {
                stepName = "_STEP_ID_SepSep_TypeIndexation";
              } else if (formControlName.includes('_idAnnonceur')) {
                stepName = "_STEP_ID_SepSep_idAnnonceur";
              }
              stepStats.set(stepName, false);
              this.stepperBuilderService.addStepFieldsOnWarnings(stepName, formControlName, formControl.value.validation_message);
            }
            subFlag--;
            if (!subFlag) {
              this.stepperBuilderService.updateStats(stepStats);
              setTimeout(() => {
                this.formulaireResponse.emit(null);
              }, 200);
            }
          });
          if (this.sub.get(formControlName)) {
            this.sub.get(formControlName).push(s);
          } else {
            this.sub.set(formControlName, [s]);
          }
        } else if (formControlName.includes('CTRL_IDWEB')) {
          const subIdWeb = this.idWebApiService.idWebResponse.subscribe(next => {
            if (formControl.value.ctrlValidation) {
              const regEx = /(\w*)((_STEP_ID_\d+(\.\d+)?)|(_COMMON_ID_\d+(\.\d+)?))(\w*)/;
              let stepName = formControlName.replace(regEx, '$2');
              if (formControlName.includes('_TypeFacturation')) {
                stepName = "_STEP_ID_SepSep_TypeFacturation";
              } else if (formControlName.includes('_TypeIndexation')) {
                stepName = "_STEP_ID_SepSep_TypeIndexation";
              } else if (formControlName.includes('_idAnnonceur')) {
                stepName = "_STEP_ID_SepSep_idAnnonceur";
              }
              stepStats.set(stepName, false);
              this.stepperBuilderService.addStepFieldsOnErrors(stepName, formControlName, formControl.value.validation_message);
              isValid = false;
            }
            subFlag--;
            if (!subFlag) {
              this.stepperBuilderService.updateStats(stepStats);
              setTimeout(() => {
                this.formulaireResponse.emit(null);
              }, 200);
            }
          });
          if (this.sub.get(formControlName)) {
            this.sub.get(formControlName).push(subIdWeb);
          } else {
            this.sub.set(formControlName, [subIdWeb]);
          }
        } else {
          if (formControl.value.ctrlValidation) {
            const regEx = regex;
            let stepName = formControlName.replace(regEx, '$2');
            if (formControlName.includes('_TypeFacturation')) {
              stepName = "_STEP_ID_SepSep_TypeFacturation";
            } else if (formControlName.includes('_TypeIndexation')) {
              stepName = "_STEP_ID_SepSep_TypeIndexation";
            } else if (formControlName.includes('_idAnnonceur')) {
              stepName = "_STEP_ID_SepSep_idAnnonceur";
            }
            stepStats.set(stepName, false);
            this.stepperBuilderService.addStepFieldsOnErrors(stepName, formControlName, formControl.value.validation_message);
            isValid = false;
          }
          if (formControl.value.ctrlValidationWarning) {
            const regEx = regex;
            let stepName = formControlName.replace(regEx, '$2');
            if (formControlName.includes('_TypeFacturation')) {
              stepName = "_STEP_ID_SepSep_TypeFacturation";
            } else if (formControlName.includes('_TypeIndexation')) {
              stepName = "_STEP_ID_SepSep_TypeIndexation";
            } else if (formControlName.includes('_idAnnonceur')) {
              stepName = "_STEP_ID_SepSep_idAnnonceur";
            }
            stepStats.set(stepName, false);
            this.stepperBuilderService.addStepFieldsOnWarnings(stepName, formControlName, formControl.value.validation_message);
          }
          subFlag--;
          if (!subFlag) {
            this.stepperBuilderService.updateStats(stepStats);
            setTimeout(() => {
              this.formulaireResponse.emit(null);
            }, 200);
          }
        }
      }

      if (formControl.invalid || formControl.errors?.required) {
        let regEx: any;
        if (formControlName.includes('_COMMON_ID_')) {
          regEx = /(\w*)(_COMMON_ID_\d+(\.\d+)?)(\w*)/;
        } else {
          regEx = /(\w*)(_STEP_ID_\d+(\.\d+)?)(\w*)/;
        }
        let stepName = formControlName.replace(regEx, '$2');
        if (formControlName.includes('_TypeFacturation')) {
          stepName = "_STEP_ID_SepSep_TypeFacturation";
        } else if (formControlName.includes('_TypeIndexation')) {
          stepName = "_STEP_ID_SepSep_TypeIndexation";
        } else if (formControlName.includes('_idAnnonceur')) {
          stepName = "_STEP_ID_SepSep_idAnnonceur";
        }
        if (stepName !== 'eforms' && (('_STEP_ID_' + stepId) === stepName || stepName === '_STEP_ID_SepSep_TypeIndexation' || stepName === '_STEP_ID_SepSep_TypeFacturation' || stepName === '_STEP_ID_SepSep_idAnnonceur')) {
          stepStats.set(stepName, false);
          isValid = false;
          Object.keys(formControl.errors).forEach(error => {
            this.stepperBuilderService.addStepFieldsOnErrors(stepName, formControlName,
              this.mapErrorToMessage(error, formControl,
                this.stepperBuilderService.stepFieldsSpecificMessages.get(formControlName)));
          });
        }
      }
    });
    if (this.canNavigateInStepperService.currentFormulaire?.includes('E_FORM_')) {
      this.http.post('/schematron/validate', this.eformsExtractorService.mapFormToAvis(form, null, this.actualFormIdAnnEmetteur.getValue())).subscribe({
        next:
          (data: { issues: any[], valid: boolean }) => {
            if (data) {
              // Éclater les erreurs de nœuds multi-champs en erreurs individuelles par champ
              const expandedIssues = this.expandNodeIssues(data.issues, this.canNavigateInStepperService.currentFormulaire);
              expandedIssues.forEach(d => {
                let location = d.location;
                if (d.location.includes('@')) {
                  location = location.substring(0, location.indexOf('@') - 1);
                }
                let messageErrors = this.surchargeMessage(this.canNavigateInStepperService.currentFormulaire, location, d.message)
                let messageTranslated = this.translate.instant('eform-not-editable.' + messageErrors);
                // Priorité au fieldId du backend
                let fieldId = d.fieldId;
                // Si le fieldId est un identifiant de nœud (ND-xxx), le mapper vers le champ principal du nœud
                if (fieldId && fieldId.startsWith('ND-')) {
                  fieldId = this.mapNodeIdToFieldId(fieldId, this.canNavigateInStepperService.currentFormulaire);
                }
                if (!fieldId) {
                  fieldId = this.getFieldIdFromMappingBack(messageErrors);
                }
                if (!fieldId) {
                  fieldId = this.getFieldIdFromMessage(messageTranslated);
                }
                if (fieldId && !this.translate.instant('eform-not-editable.field|name|' + fieldId).includes('eform-not-editable.field|name|')) {
                  messageTranslated = this.translate.instant('eform-not-editable.field|name|' + fieldId) + " - " + messageTranslated
                }

                //On vérifie si le chemin de l'erreur correspond à un objet duplicable
                let isIntoDuplicableObject = this.isPathCorrespondingToDuplicableObject(location);

                // Si pas détecté via le path, vérifier via le suffixe du fieldId
                if (!isIntoDuplicableObject && fieldId) {
                  isIntoDuplicableObject = this.isDuplicableObjectFromFieldId(fieldId, location);
                }

                let lotIndex = 0;
                //Si oui, on récupère l'index
                if (isIntoDuplicableObject) {
                  lotIndex = this.getIndexForDuplicableObjects(location);
                }
                let findGroupForm = form?.controls?.eforms ? this.findFormControl(location, form.controls.eforms, isIntoDuplicableObject) : null;
                let findInputForm = this.findInputForm(fieldId, findGroupForm);

                // Si la recherche dans le groupe échoue et qu'on a un fieldId, chercher dans tout le formulaire
                if (!findInputForm && fieldId && form?.controls?.eforms) {
                  findInputForm = this.findInputForm(fieldId, form.controls.eforms);
                }

                let locationErrors = "undefined|undefined";
                if (findInputForm && findInputForm.controls['val'] && findInputForm.controls['val'].idInput) {
                  locationErrors = this.findCorrectLocation(findInputForm.controls['val'].idInput, lotIndex);
                  if (findInputForm.controls['val'].idInput === 'null|null') {
                    locationErrors = findInputForm.parent.idInput;
                  }

                  // Si le locationErrors contient 'undefined', chercher un champ alternatif dans le message
                  if (locationErrors && locationErrors.includes('undefined')) {
                    const alternativeFieldIds = this.extractFieldIdsFromMessage(messageTranslated);
                    for (const altFieldId of alternativeFieldIds) {
                      if (altFieldId !== fieldId) {
                        const altInputForm = this.findInputForm(altFieldId, findGroupForm) || this.findInputForm(altFieldId, form?.controls?.eforms);
                        if (altInputForm && altInputForm.controls['val'] && altInputForm.controls['val'].idInput) {
                          const altLocation = this.findCorrectLocation(altInputForm.controls['val'].idInput, lotIndex);
                          if (altLocation && !altLocation.includes('undefined')) {
                            locationErrors = altLocation;
                            break;
                          }
                        }
                      }
                    }
                  }
                }else if('rule|text|element-not-empty' === messageErrors && findGroupForm && findGroupForm.idInput){
                  locationErrors = findGroupForm.idInput;
                }else if(!findInputForm && fieldId){
                  // Certains champs (ex: BT-615-Lot,
                  // conditionné par BT-14-Lot) ne sont affichés/instanciés dans le formulaire que sous
                  // certaines conditions. Quand la condition est remplie mais que le champ n'a pas encore
                  // été rendu au moment où l'erreur schematron arrive, findInputForm échoue et on tombe
                  // dans le fallback générique ci-dessous, qui fige artificiellement l'index de
                  // sous-section à 0 (GR-Lot_{index}_0) - "Procédure de passation" - quelle que soit la
                  // vraie sous-section du champ (ici "Informations sur la présentation", index 2).
                  //
                  // On tente donc d'abord un alias : un autre champ, structurellement dans le MÊME
                  // groupe/sous-section, mais SANS condition d'affichage (donc toujours rendu), pour
                  // récupérer son idInput réel - qui porte le bon index de sous-section.
                  const conditionalFieldAliases: { [key: string]: string } = {
                    'BT-615-Lot': 'BT-14-Lot',   // même sous-section (Informations sur les documents de marché),
                    // BT-14-Lot n'a aucune forbiddenConditionV2 (toujours rendu)
                  };
                  const aliasFieldId = conditionalFieldAliases[fieldId];
                  const aliasInputForm = aliasFieldId
                    ? (this.findInputForm(aliasFieldId, findGroupForm) || this.findInputForm(aliasFieldId, form?.controls?.eforms))
                    : null;
                  if (aliasInputForm && aliasInputForm.controls['val'] && aliasInputForm.controls['val'].idInput) {
                    locationErrors = aliasInputForm.controls['val'].idInput;
                  } else if (isIntoDuplicableObject) {
                    // L'élément duplicable n'est pas chargé, construire une location artificielle
                    // (pour LotTender, Contract, Tenderer, LotResult, Organization et aussi pour les champs Lot
                    // qui ne sont pas trouvés, ex: BT-92-Lot, BT-93-Lot dans un groupe conditionnel non chargé)
                    locationErrors = this.buildLocationForUnloadedDuplicableObject(location, fieldId, lotIndex, form);
                  } else {
                    // Champ caché ou non trouvé -> bandeau gris
                    locationErrors = 'undefined|undefined';
                  }
                }
                /*PRB0053499: traiter le champ en dur ici pour remplacer 615 par 15.
                Il s'agit d'un problème de fond: jsonPath n'est pas unique pour chaque champ, il ne permet donc pas de les identifier en tant que clé.
                Avoir un seul élément "controle" par jsonPath serait alors problématique.
                Dans l'application un seul élément de contrôle est créé pour représenter les 2 champs car ils ont le même jsonPath.
                Cette problématique est connu, une recherche du mot BT-15-Lot dans le code et ses commentaires nous liste les différentes adaptations pour la contourner.
                Une solution générique reviendrait coutêuse avec beaucoup de risques de régression.
                */
                if (fieldId === 'BT-15-Lot') {
                  locationErrors = locationErrors.replace('-615-', '-15-');
                }
                this.stepperBuilderService.eformSchematronsErrors.push({
                  "location": locationErrors,
                  "message": messageTranslated,
                  "severity": d.severity
                });
              });
              this.stepperBuilderService.eformSchematronsErrors.forEach(schematron => {
                if (schematron.severity === 'error') {
                  isValid = false;
                  let stepId = this.getStepIdFromLocation(schematron.location);
                  // Si le stepId est undefined, vide, null, contient 'undefined', ou une section non trouvée
                  if (!stepId || stepId === '' || stepId === 'null' || schematron.location === 'undefined|undefined' || stepId.includes('undefined')) {
                    stepId = 'undefined';
                  } else if (stepId.endsWith('-Section') && stepId.startsWith('GR-')) {
                    // Si c'est une section duplicable non trouvée (commence par GR- et finit par -Section)
                    stepId = 'undefined';
                  }
                  this.stepperBuilderService.addStepFieldsOnErrors(stepId, schematron.location, schematron.message);
                } else if (schematron.severity === 'warning') {
                  let stepId = this.getStepIdFromLocation(schematron.location);
                  if (!stepId || stepId === '' || stepId === 'null' || schematron.location === 'undefined|undefined' || stepId.includes('undefined')) {
                    stepId = 'undefined';
                  } else if (stepId.endsWith('-Section') && stepId.startsWith('GR-')) {
                    stepId = 'undefined';
                  }
                  this.stepperBuilderService.addStepFieldsOnWarnings(stepId, schematron.location, schematron.message);
                }
              });
              subFlag--;
              //if (!subFlag) {
              this.stepperBuilderService.updateStats(stepStats);
              setTimeout(() => {
                this.formulaireResponse.emit(null);
                isValid = data.valid && isValid;
              }, 200);
              //}
            }
            if (exportXml) {
              onFinish();
              this.isValidObs.next(isValid);
            }
          }
      });
    } else {
      if (exportXml) {
        onFinish();
        this.isValidObs.next(isValid);
      }
    }
    subFlag--;
    if (!subFlag) {
      this.stepperBuilderService.updateStats(stepStats);
      setTimeout(() => {
        this.formulaireResponse.emit(null);
      }, 200);
    }
  }

  /**
   * Récupére l'index d'un objet répétable à partir du path
   * @param path
   * @private
   */
  private getIndexForDuplicableObjects(path: string): number {
    let lotIndex = 0;
    // Supprimer les index [0], [1], [2]... pour comparer uniquement les noms des éléments
    let cleanedPath = path.replace(/\[\d+\]/g, "");
    for (let duplicableObjetPath of Object.values(DuplicableElementPartialPathsEnum)) {
      if (cleanedPath.includes(duplicableObjetPath)) {
        // Récupérer le dernier élément du duplicableObjetPath
        const pathParts = duplicableObjetPath.split('.');
        const lastElement = pathParts[pathParts.length - 1];

        // Créer une regex qui cherche le lastElement suivi de [index]
        const regex = new RegExp(`${lastElement}\\[(\\d+)\\]`);
        const match = path.match(regex);

        if (match) {
          lotIndex = parseInt(match[1], 10);
          break;
        }
      }
    }
    return lotIndex;
  }

  private findCorrectLocation(locationErrors, index): string {
    if (!locationErrors) {
      return 'undefined|undefined';
    }
    if (locationErrors.includes('GR-Lot') || locationErrors.includes('GR-Part')) {
      //Pour les objets duplicables, on n'en charge qu'un seul à la fois pour des raisons de performance mais il faut qu'ils aient des
      //localisations différentes pour pouvoir les identifier. On utilise l'index de l'objet duplicable.
      //Pour les parts et lots, il faut modifier le premier chiffre correspondant à l'index de la step
      const oldPrefix = locationErrors.split('|')[0];
      let splittedPrefix = oldPrefix.split('_');
      //On remplace le 0 par le réel index
      splittedPrefix[1] = index;
      //On reforme la chaîne de charactéres
      let newPrefix = splittedPrefix.join('_');
      //On met à jour le prefix
      locationErrors = locationErrors.replace(oldPrefix, newPrefix);
    } else {
      for (let duplicableObjetName of Object.values(DuplicableElementIdPartEnum)) {
        if (locationErrors.includes(duplicableObjetName)) {
          //Pour les autres objets duplicables, il faut modifier l'index qui est dans la 2eme partie car il s'agit de groupes
          const oldSecondPart = locationErrors.split('|')[1];
          let splittedPrefix = oldSecondPart.split('_');
          //On remplace le 0 par le réel index
          splittedPrefix[1] = index;
          //On reforme la chaîne de charactéres
          let newSecondPart = splittedPrefix.join('_');
          //On met à jour
          locationErrors = locationErrors.replace(oldSecondPart, newSecondPart);
          const [prefix, ...rest] = locationErrors.split('|');
          locationErrors = [this.setDuplicableSectionIndex(prefix, index), ...rest].join('|');
          break;
        }
      }
    }
    return locationErrors;
  }

  /**
   * PRB0053438 : pour une section duplicable (ex: GR-Organisations-Section), le DOM distingue les éléments
   * par le dernier chiffre du préfixe (GR-Organisations-Section_0_{index}|...), cf. section.component.html.
   * L'idInput du contrôle trouvé est celui du dernier élément chargé (un seul est chargé à la fois) :
   * sans correction, une erreur de l'ORG-0001 relevée pendant que l'ORG-0002 est chargée pointait vers
   * GR-Organisations-Section_0_1|..., id introuvable une fois l'ORG-0001 ouverte depuis le bandeau d'erreurs.
   * On aligne donc le préfixe sur l'index réel de l'élément en erreur.
   * Tout autre préfixe est retourné tel quel.
   */
  private setDuplicableSectionIndex(prefix: string, index: number): string {
    const splittedPrefix = prefix.split('_');
    const sectionId = splittedPrefix[0];
    if (splittedPrefix.length !== 3 || !sectionId.endsWith('-Section')
      || !Object.keys(DuplicableElementSubSectionIdEnum).includes(sectionId)) {
      return prefix;
    }
    splittedPrefix[2] = String(index);
    return splittedPrefix.join('_');
  }

  /**
   * PRB0053438 : le stepId d'une erreur est le préfixe de sa location. Pour une section duplicable, ce préfixe
   * porte désormais l'index de l'élément en erreur (cf. setDuplicableSectionIndex), alors que le stepper et le
   * bandeau d'erreurs de la section lisent les erreurs sous la clé de la section (ex: GR-Organisations-Section_0_0).
   * On ramène donc toutes les erreurs de la section sur cette clé, quel que soit l'élément concerné.
   */
  private getStepIdFromLocation(location: string): string {
    const stepId = location?.split('|')[0];
    return stepId ? this.setDuplicableSectionIndex(stepId, 0) : stepId;
  }

  /**
   * Construit une location artificielle pour un champ dans un objet duplicable non chargé
   * @param location Le JSON path du backend (ex: $.ContractAwardNotice[0]...LotTender[0])
   * @param fieldId L'ID du champ (ex: BT-773-Tender)
   * @param index L'index de l'objet duplicable
   * @param form Le formulaire pour chercher un stepId existant
   * @private
   */
  private buildLocationForUnloadedDuplicableObject(location: string, fieldId: string, index: number, form?: any): string {
    // Déterminer le type d'objet duplicable depuis le location
    let duplicableType = '';
    let duplicableKey = '';
    let sectionId = '';

    if (location.includes('LotTender')) {
      duplicableType = DuplicableElementIdPartEnum['GR-LotTender'];
      duplicableKey = 'GR-LotTender';
      sectionId = 'GR-LotTender-Section';
    } else if (location.includes('SettledContract')) {
      duplicableType = DuplicableElementIdPartEnum['GR-SettledContract'];
      duplicableKey = 'GR-SettledContract';
      sectionId = 'GR-SettledContract-Section';
    } else if (location.includes('TenderingParty')) {
      duplicableType = DuplicableElementIdPartEnum['GR-TenderingParty'];
      duplicableKey = 'GR-TenderingParty';
      sectionId = 'GR-TenderingParty-Section';
    } else if (location.includes('LotResult')) {
      duplicableType = DuplicableElementIdPartEnum['GR-LotResult'];
      duplicableKey = 'GR-LotResult';
      sectionId = 'GR-LotResult-Section';
    } else if (location.includes('Organization')) {
      duplicableType = DuplicableElementIdPartEnum['GR-Organisations'];
      duplicableKey = 'GR-Organisations';
      sectionId = 'GR-Organisations-Section';
    } else if (location.includes('ProcurementProjectLot')) {
      duplicableType = DuplicableElementIdPartEnum['GR-Lot'];
      duplicableKey = 'GR-Lot';
      sectionId = 'GR-Lot';
    } else if (fieldId) {
      // Si le location ne contient pas le type, essayer de le déduire du suffixe du fieldId
      const suffix = fieldId.split('-').pop();
      if (suffix === 'Tender') {
        duplicableType = DuplicableElementIdPartEnum['GR-LotTender'];
        duplicableKey = 'GR-LotTender';
        sectionId = 'GR-LotTender-Section';
      } else if (suffix === 'Contract') {
        duplicableType = DuplicableElementIdPartEnum['GR-SettledContract'];
        duplicableKey = 'GR-SettledContract';
        sectionId = 'GR-SettledContract-Section';
      } else if (suffix === 'Tenderer') {
        duplicableType = DuplicableElementIdPartEnum['GR-TenderingParty'];
        duplicableKey = 'GR-TenderingParty';
        sectionId = 'GR-TenderingParty-Section';
      } else if (suffix === 'LotResult') {
        duplicableType = DuplicableElementIdPartEnum['GR-LotResult'];
        duplicableKey = 'GR-LotResult';
        sectionId = 'GR-LotResult-Section';
      } else if (suffix === 'Organization') {
        duplicableType = DuplicableElementIdPartEnum['GR-Organisations'];
        duplicableKey = 'GR-Organisations';
        sectionId = 'GR-Organisations-Section';
      } else if (suffix === 'Lot') {
        duplicableType = DuplicableElementIdPartEnum['GR-Lot'];
        duplicableKey = 'GR-Lot';
        sectionId = 'GR-Lot';
      }
    }

    if (duplicableType) {
      // Chercher le stepId de la section parente dans le stepper
      let stepId = this.findStepIdForSection(sectionId);

      // Si pas trouvé dans le stepper, essayer de chercher dans le formulaire chargé
      if (!stepId || stepId === 'null') {
        stepId = this.findStepIdForDuplicableType(duplicableKey, form);
      }

      // Si toujours pas trouvé, utiliser le sectionId directement comme stepId
      // Cela permettra au moins d'associer l'erreur à la section
      if (!stepId || stepId === 'null') {
        stepId = sectionId;
      }

      // Construire la location au format différent selon le type
      // Pour les Lots: GR-Lot_{index}_0|{fieldId}_{lotIndex} (ex: GR-Lot_2_0|BT-137-Lot_2)
      // Pour les autres: stepId|duplicableType_index_fieldId (ex: GR-Result_0_0|Tender_0_OPT-321-Tender)
      let resultLocation: string;
      if (duplicableKey === 'GR-Lot') {
        // Injecter l'index du lot dans le stepId pour que l'erreur soit associée au bon lot
        // Le stepper génère les stepId au format GR-Lot_{lotIndex}_0 (ex: GR-Lot_0_0 pour lot 1, GR-Lot_1_0 pour lot 2)
        const lotStepId = `GR-Lot_${index}_0`;
        resultLocation = `${lotStepId}|${fieldId}_${index}`;
      } else {
        resultLocation = `${stepId}|${duplicableType}${index}_${fieldId}`;
      }
      return resultLocation;
    }

    // Si le type duplicable n'a pas pu être déterminé, retourner une location par défaut
    return "undefined|undefined";
  }

  /**
   * Cherche le stepId d'une section dans le stepper
   * @param sectionId L'ID de la section (ex: GR-LotTender-Section)
   * @private
   */
  private findStepIdForSection(sectionId: string): string {
    const steps = this.stepperBuilderService.stepper.getValue();

    if (steps && steps.length > 0) {
      // Mapper les sections duplicables vers leur step parent
      // LotTender, SettledContract, TenderingParty sont tous dans le step NoticeResult (GR-Result)
      const sectionToEformName = {
        'GR-LotTender-Section': 'GR-Result',
        'GR-SettledContract-Section': 'GR-Result',
        'GR-TenderingParty-Section': 'GR-Result',
        'GR-LotResult-Section': 'GR-Result',
        'GR-Organisations-Section': 'GR-Organisations-Section',
        'GR-Lot': 'GR-Lot'
      };

      const targetEformName = sectionToEformName[sectionId];

      // Chercher le step qui a le bon eformName
      if (targetEformName) {
        for (const step of steps) {
          if (step.eformName === targetEformName) {
            // Utiliser step.eformName pour construire le stepId, car c'est ce que le stepper component utilise
            // Le stepper remplace 'ND' par 'GR' dans eformName, donc nous utilisons directement eformName
            let stepIdStr = step.eformName + '_0_0';
            return stepIdStr;
          }
        }
      }

      // Fallback : recherche exacte par eformName ou libellé
      for (const step of steps) {
        const libelleMatch = typeof step.libelle === 'string' && step.libelle.includes(sectionId);
        const stepIdStr = step.id != null ? String(step.id) : '';
        const idMatch = stepIdStr.includes(sectionId);
        const eformNameMatch = step.eformName === sectionId;

        if (libelleMatch || idMatch || eformNameMatch) {
          if (step.id != null) {
            return stepIdStr;
          }
        }
      }
    }

    return 'null';
  }

  /**
   * Cherche le stepId d'un type d'objet duplicable dans le formulaire
   * @param duplicableKey Le nom de l'objet duplicable (ex: GR-LotTender)
   * @param form Le formulaire
   * @private
   */
  private findStepIdForDuplicableType(duplicableKey: string, form: any): string {
    // Chercher récursivement un control qui contient ce type d'objet duplicable dans son idInput
    const subSectionId = DuplicableElementSubSectionIdEnum[duplicableKey];
    if (subSectionId && form?.controls?.eforms) {
      const foundStepId = this.searchStepIdInForm(form.controls.eforms, subSectionId);
      if (foundStepId) {
        return foundStepId;
      }
    }
    return 'null';
  }

  /**
   * Recherche récursive du stepId dans le formulaire
   * @param formGroup Le groupe de formulaire
   * @param subSectionId Le sous-section ID à chercher (ex: TEN, CON)
   * @private
   */
  private searchStepIdInForm(formGroup: any, subSectionId: string): string | null {
    if (!formGroup) return null;

    // Si c'est un control avec idInput qui contient le subSectionId
    if (formGroup.idInput && formGroup.idInput.includes(subSectionId)) {
      const stepId = formGroup.idInput.split('|')[0];
      if (stepId && stepId !== 'null' && stepId !== 'undefined') {
        return stepId;
      }
    }

    // Recherche récursive dans les controls
    if (formGroup.controls) {
      if (Array.isArray(formGroup.controls)) {
        for (const control of formGroup.controls) {
          const result = this.searchStepIdInForm(control, subSectionId);
          if (result) return result;
        }
      } else {
        for (const key of Object.keys(formGroup.controls)) {
          const result = this.searchStepIdInForm(formGroup.controls[key], subSectionId);
          if (result) return result;
        }
      }
    }

    return null;
  }

  private getFieldIdFromMessage(message): string {
    const splittedMessage = message.split(' ');
    let fieldId = '';
    for (const messagePart of splittedMessage) {
      if (messagePart.includes('OPT-') || messagePart.includes('BT-')) {
        fieldId = messagePart;
        if (fieldId?.startsWith('(')) {
          fieldId = fieldId.replace('(', '')
        }
        if (fieldId?.endsWith(')')) {
          fieldId = fieldId.substring(0, fieldId.lastIndexOf(')'))
        }
        break;
      }
    }
    return fieldId;
  }

  /**
   * Extrait tous les identifiants de champs (BT-xxx, OPT-xxx) d'un message d'erreur
   * @param message Le message traduit contenant potentiellement plusieurs fieldIds
   * @returns Un tableau de tous les fieldIds trouvés
   */
  private extractFieldIdsFromMessage(message: string): string[] {
    const fieldIds: string[] = [];
    if (!message) return fieldIds;

    // Regex pour trouver tous les identifiants BT-xxx-Yyy ou OPT-xxx-Yyy
    const regex = /\b(BT-\d+[-\w]*|OPT-\d+[-\w]*)\b/g;
    let match;
    while ((match = regex.exec(message)) !== null) {
      let fieldId = match[1];
      // Nettoyer les parenthèses si présentes
      if (fieldId.startsWith('(')) {
        fieldId = fieldId.substring(1);
      }
      if (fieldId.endsWith(')') || fieldId.endsWith(',') || fieldId.endsWith('.')) {
        fieldId = fieldId.substring(0, fieldId.length - 1);
      }
      if (!fieldIds.includes(fieldId)) {
        fieldIds.push(fieldId);
      }
    }
    return fieldIds;
  }

  private getFieldIdFromMappingBack(idMessage): string {
    let fieldId = '';
    if (this.autoCompleteService.eformBandeauErreurMappingSubject.getValue()) {
      fieldId = this.autoCompleteService.eformBandeauErreurMappingSubject.getValue().filter(e => e.idMessage === idMessage)[0]?.idTarget;
    }
    return fieldId;
  }

  /**
   * Éclate les erreurs de nœuds (ND-xxx) qui contiennent plusieurs champs obligatoires
   * en autant d'erreurs individuelles qu'il y a de champs.
   * Par exemple, ND-PostAwardProcess contient BT-92-Lot et BT-93-Lot.
   * Sans cet éclatement, seul le premier champ mappé serait affiché comme erreur.
   */
  private expandNodeIssues(issues: any[], formName: string): any[] {
    // Mapping des nœuds multi-champs : pour chaque nœud, la liste des champs obligatoires par formulaire.
    // Si 'message' est null, le message original du nœud est conservé (préfixé par le nom du champ à l'affichage).
    const multiFieldNodes: { [nodeId: string]: { [formName: string]: { fieldId: string, message: string }[] } } = {
      'ND-PostAwardProcess': {
        'E_FORM_16': [
          { fieldId: 'BT-92-Lot', message: 'rule|text|BR-BT-00092-0022' },
          { fieldId: 'BT-93-Lot', message: 'rule|text|BR-BT-00093-0022' },
        ],
      },
      'ND-ProcedureTenderingProcess': {
        'E_FORM_16': [
          { fieldId: 'BT-105-Procedure', message: null },
          { fieldId: 'BT-106-Procedure', message: null },
        ],
      },
      'ND-ProcedureTerms': {
        'E_FORM_16': [
          { fieldId: 'BT-806-Procedure', message: null },
          { fieldId: 'BT-67(a)-Procedure', message: null },
        ],
      },
      'ND-PartProcurementScope': {
        'E_FORM_4': [
          { fieldId: 'BT-21-Part', message: 'rule|text|BR-BT-00021-0059' },
          { fieldId: 'BT-24-Part', message: 'rule|text|BR-BT-00024-0059' },
          { fieldId: 'BT-23-Part', message: 'rule|text|BR-BT-00023-0058' },
          { fieldId: 'BT-262-Part', message: 'rule|text|BR-BT-00262-0057' },
        ],
        'E_FORM_5': [
          { fieldId: 'BT-21-Part', message: 'rule|text|BR-BT-00021-0060' },
          { fieldId: 'BT-24-Part', message: 'rule|text|BR-BT-00024-0060' },
          { fieldId: 'BT-23-Part', message: 'rule|text|BR-BT-00023-0059' },
          { fieldId: 'BT-262-Part', message: 'rule|text|BR-BT-00262-0058' },
        ],
        'E_FORM_6': [
          { fieldId: 'BT-21-Part', message: 'rule|text|BR-BT-00021-0061' },
          { fieldId: 'BT-24-Part', message: 'rule|text|BR-BT-00024-0061' },
          { fieldId: 'BT-23-Part', message: 'rule|text|BR-BT-00023-0060' },
          { fieldId: 'BT-262-Part', message: 'rule|text|BR-BT-00262-0059' },
        ],
        'E_FORM_E2': [
          { fieldId: 'BT-21-Part', message: 'rule|text|BR-BT-00021-0062' },
          { fieldId: 'BT-24-Part', message: 'rule|text|BR-BT-00024-0062' },
          { fieldId: 'BT-23-Part', message: 'rule|text|BR-BT-00023-0061' },
          { fieldId: 'BT-262-Part', message: 'rule|text|BR-BT-00262-0060' },
        ],
      },
      'ND-PartTenderingTerms': {
        'E_FORM_6': [
          { fieldId: 'OPT-111-Part-FiscalLegis', message: 'rule|text|BR-OPT-00111-0009' },
          { fieldId: 'OPT-112-Part-EnvironLegis', message: 'rule|text|BR-OPT-00112-0009' },
          { fieldId: 'OPT-113-Part-EmployLegis', message: 'rule|text|BR-OPT-00113-0009' },
        ],
      },
      'ND-ContractModification': {
        'E_FORM_38': [
          { fieldId: 'BT-1501(n)-Contract', message: 'rule|text|BR-BT-01501-0047' },
          { fieldId: 'BT-1501(c)-Contract', message: 'rule|text|BR-BT-01501-0196' },
          { fieldId: 'BT-202-Contract', message: 'rule|text|BR-BT-00202-0047' },
          { fieldId: 'BT-200-Contract', message: 'rule|text|BR-BT-00200-0047' },
          { fieldId: 'BT-201-Contract', message: 'rule|text|BR-BT-00201-0047' },
        ],
        'E_FORM_39': [
          { fieldId: 'BT-1501(n)-Contract', message: 'rule|text|BR-BT-01501-0048' },
          { fieldId: 'BT-1501(c)-Contract', message: 'rule|text|BR-BT-01501-0197' },
          { fieldId: 'BT-202-Contract', message: 'rule|text|BR-BT-00202-0048' },
          { fieldId: 'BT-200-Contract', message: 'rule|text|BR-BT-00200-0048' },
          { fieldId: 'BT-201-Contract', message: 'rule|text|BR-BT-00201-0048' },
        ],
        'E_FORM_40': [
          { fieldId: 'BT-1501(n)-Contract', message: 'rule|text|BR-BT-01501-0049' },
          { fieldId: 'BT-1501(c)-Contract', message: 'rule|text|BR-BT-01501-0198' },
          { fieldId: 'BT-202-Contract', message: 'rule|text|BR-BT-00202-0049' },
          { fieldId: 'BT-200-Contract', message: 'rule|text|BR-BT-00200-0049' },
          { fieldId: 'BT-201-Contract', message: 'rule|text|BR-BT-00201-0049' },
        ],
        'E_FORM_E6': [
          { fieldId: 'BT-1501(n)-Contract', message: 'rule|text|BR-BT-01501-0051' },
          { fieldId: 'BT-1501(c)-Contract', message: 'rule|text|BR-BT-01501-0253' },
          { fieldId: 'BT-202-Contract', message: 'rule|text|BR-BT-00202-0052' },
          { fieldId: 'BT-200-Contract', message: 'rule|text|BR-BT-00200-0051' },
          { fieldId: 'BT-201-Contract', message: 'rule|text|BR-BT-00201-0052' },
        ],
      },
      'ND-LotProcurementScope': {
        'E_FORM_38': [
          { fieldId: 'BT-24-Lot', message: 'rule|text|BR-BT-00024-0203' },
        ],
        'E_FORM_39': [
          { fieldId: 'BT-24-Lot', message: 'rule|text|BR-BT-00024-0204' },
        ],
        'E_FORM_40': [
          { fieldId: 'BT-24-Lot', message: 'rule|text|BR-BT-00024-0205' },
        ],
        'E_FORM_E6': [
          { fieldId: 'BT-24-Lot', message: 'rule|text|BR-BT-00024-0211' },
        ],
      },
    };

    // Mapping formulaire → suffixe de règle BR-BT pour construire dynamiquement les messages
    const formToRuleSuffix: { [formName: string]: string } = {
      'E_FORM_1': '0004', 'E_FORM_2': '0005', 'E_FORM_3': '0006', 'E_FORM_4': '0007',
      'E_FORM_5': '0008', 'E_FORM_6': '0009', 'E_FORM_7': '0012', 'E_FORM_8': '0013',
      'E_FORM_9': '0014', 'E_FORM_10': '0015', 'E_FORM_11': '0016', 'E_FORM_12': '0018',
      'E_FORM_13': '0019', 'E_FORM_14': '0020', 'E_FORM_15': '0021', 'E_FORM_16': '0022',
      'E_FORM_17': '0023', 'E_FORM_18': '0024', 'E_FORM_19': '0025', 'E_FORM_20': '0027',
      'E_FORM_21': '0028', 'E_FORM_22': '0029', 'E_FORM_23': '0030', 'E_FORM_24': '0031',
      'E_FORM_25': '0032', 'E_FORM_26': '0033', 'E_FORM_27': '0034', 'E_FORM_28': '0035',
      'E_FORM_29': '0036', 'E_FORM_30': '0037', 'E_FORM_31': '0038', 'E_FORM_32': '0039',
      'E_FORM_33': '0042', 'E_FORM_34': '0043', 'E_FORM_35': '0044', 'E_FORM_36': '0045',
      'E_FORM_37': '0046', 'E_FORM_38': '0047', 'E_FORM_39': '0048', 'E_FORM_40': '0049',
      'E_FORM_CEI': '0017', 'E_FORM_E1': '0003', 'E_FORM_E2': '0010', 'E_FORM_E3': '0026',
      'E_FORM_E4': '0040', 'E_FORM_E5': '0050', 'E_FORM_E6': '0051',
      'E_FORM_T01': '0011', 'E_FORM_T02': '0041',
    };

    // Expansion dynamique de ND-ProcedureProcurementScope pour tous les formulaires
    if (formToRuleSuffix[formName]) {
      const suffix = formToRuleSuffix[formName];
      multiFieldNodes['ND-ProcedureProcurementScope'] = {
        [formName]: [
          { fieldId: 'BT-21-Procedure', message: 'rule|text|BR-BT-00021-' + suffix },
          { fieldId: 'BT-24-Procedure', message: 'rule|text|BR-BT-00024-' + suffix },
          { fieldId: 'BT-23-Procedure', message: 'rule|text|BR-BT-00023-' + suffix },
          { fieldId: 'BT-26(m)-Procedure', message: 'rule|text|BR-BT-00026-' + suffix },
          { fieldId: 'BT-5141-Procedure', message: 'rule|text|BR-BT-05141-' + suffix },
        ],
      };

      // Expansion dynamique de ND-SettledContract (BT-150-Contract + OPT-316-Contract)
      multiFieldNodes['ND-SettledContract'] = multiFieldNodes['ND-SettledContract'] || {};
      multiFieldNodes['ND-SettledContract'][formName] = [
        { fieldId: 'BT-150-Contract', message: 'rule|text|BR-BT-00150-' + suffix },
        { fieldId: 'OPT-316-Contract', message: 'rule|text|BR-OPT-00316-' + suffix },
      ];

      // Expansion dynamique de ND-LotResult (BT-142-LotResult + OPT-322-LotResult)
      multiFieldNodes['ND-LotResult'] = multiFieldNodes['ND-LotResult'] || {};
      multiFieldNodes['ND-LotResult'][formName] = [
        { fieldId: 'BT-142-LotResult', message: 'rule|text|BR-BT-00142-' + suffix },
        { fieldId: 'OPT-322-LotResult', message: 'rule|text|BR-OPT-00322-' + suffix },
      ];

      // Expansion dynamique de ND-ModificationReason (BT-200-Contract + BT-201-Contract)
      multiFieldNodes['ND-ModificationReason'] = multiFieldNodes['ND-ModificationReason'] || {};
      multiFieldNodes['ND-ModificationReason'][formName] = [
        { fieldId: 'BT-200-Contract', message: 'rule|text|BR-BT-00200-' + suffix },
        { fieldId: 'BT-201-Contract', message: 'rule|text|BR-BT-00201-' + suffix },
      ];
    }

    const expandedIssues = [];
    for (const issue of issues) {
      const nodeId = issue.fieldId;
      if (nodeId && multiFieldNodes[nodeId] && multiFieldNodes[nodeId][formName]) {
        for (const field of multiFieldNodes[nodeId][formName]) {
          expandedIssues.push({
            ...issue,
            fieldId: field.fieldId,
            message: field.message || issue.message,
          });
        }
      } else {
        expandedIssues.push(issue);
      }
    }
    return expandedIssues;
  }

  /**
   * Mappe un identifiant de nœud schematron (ND-xxx) vers l'identifiant du champ principal (BT-xxx) contenu dans ce nœud.
   * Lorsqu'un nœud parent obligatoire est absent du XML (ex: cac:TenderingProcess), le schematron remonte une erreur
   * au niveau du nœud et non du champ individuel. Ce mapping permet de transformer cette erreur en alerte cliquable
   * pointant vers le champ principal du formulaire.
   * @param nodeId L'identifiant du nœud (ex: ND-ProcedureTenderingProcess)
   * @returns L'identifiant du champ principal ou une chaîne vide si pas de mapping
   */
  private mapNodeIdToFieldId(nodeId: string, formName?: string): string {
    // Mappings simples (identiques pour tous les types de formulaires)
    const nodeToFieldMapping = {
      // Nœuds au niveau Procédure
      'ND-ProcedureTenderingProcess': 'BT-105-Procedure',
      'ND-ProcedureProcurementScope': 'BT-21-Procedure',
      'ND-ProcedureTerms': 'BT-806-Procedure',
      // Nœuds au niveau Lot
      'ND-LotProcurementScope': 'BT-21-Lot',
      'ND-LotTenderingProcess': 'BT-17-Lot',
      'ND-LotTenderingTerms': 'BT-60-Lot',
      'ND-LotProcurementDocument': 'BT-14-Lot',
      'ND-PostAwardProcess': 'BT-92-Lot',
      'ND-AuctionTerms': 'BT-767-Lot',
      'ND-LotReviewTerms': 'BT-99-Lot',
      'ND-FSR': 'BT-681-Lot',
      'ND-LotAwardCriteria': 'BT-539-Lot',
      // Nœuds au niveau Part
      'ND-PartProcurementScope': 'BT-21-Part',
      'ND-PartTenderingTerms': 'BT-21-Part',
      'ND-PartReviewTerms': 'BT-99-Part',
      'ND-PartEmploymentLegislation': 'BT-21-Part',
      'ND-PartEnvironmentalLegislation': 'BT-21-Part',
      'ND-PartFiscalLegislation': 'BT-21-Part',
      // Nœuds au niveau Modification de contrat
      'ND-ContractModification': 'BT-1501(n)-Contract',
      'ND-Modification': 'BT-202-Contract',
      'ND-ModificationReason': 'BT-200-Contract',
      // Nœuds au niveau Lot — compléments
      'ND-PaymentTerms': 'BT-77-Lot',
      'ND-OptionsAndRenewals': 'BT-58-Lot',
      'ND-NonUBLTenderingTerms': 'BT-651-Lot',
      'ND-LotTenderingProcessExtension': 'BT-630(d)-Lot',
      'ND-InterestExpressionReceptionPeriod': 'BT-630(d)-Lot',
      'ND-PMCAnswersDeadline': 'BT-630(d)-Lot',
      'ND-LotDuration': 'BT-781-Lot',
      'ND-LotEmploymentLegislation': 'OPT-113-Lot-EmployLegis',
      'ND-LotEnvironmentalLegislation': 'OPT-112-Lot-EnvironLegis',
      'ND-LotFiscalLegislation': 'OPT-111-Lot-FiscalLegis',
      // Nœuds au niveau Part — compléments
      'ND-Part': 'BT-137-Part',
      // Nœuds au niveau Résultat
      'ND-NoticeResult': 'OPT-321-Tender',
      'ND-SettledContract': 'BT-150-Contract',
      'ND-LotResult': 'BT-142-LotResult',
      'ND-LotTender': 'BT-3201-Tender',
    };

    // Mappings dépendants du type de formulaire (quand le champ principal diffère selon le formulaire)
    const formSpecificMapping: { [nodeId: string]: { [formName: string]: string } } = {
      'ND-AwardingTerms': {
        'E_FORM_23': 'BT-41-Lot',
        'E_FORM_24': 'BT-41-Lot',
        'E_FORM_29': 'BT-539-Lot',
        'E_FORM_31': 'BT-539-Lot',
        'E_FORM_32': 'BT-539-Lot',
      },
      'ND-LotProcurementScope': {
        'E_FORM_38': 'BT-24-Lot',
        'E_FORM_39': 'BT-24-Lot',
        'E_FORM_40': 'BT-24-Lot',
        'E_FORM_E6': 'BT-24-Lot',
      },
      'ND-LotTenderingProcessExtension': {
        'E_FORM_E1': 'BT-800(d)-Lot',
      },
      'ND-PMCAnswersDeadline': {
        'E_FORM_E1': 'BT-800(d)-Lot',
      },
    };

    // Vérifier d'abord les mappings dépendants du formulaire
    if (formName && formSpecificMapping[nodeId] && formSpecificMapping[nodeId][formName]) {
      return formSpecificMapping[nodeId][formName];
    }

    return nodeToFieldMapping[nodeId] || '';
  }

  /**
   * Search recursively into object to retrieve form part for input
   * @param fieldId
   * @param formGroup
   * @private
   */
  private findInputForm(fieldId, formGroup): any {
    let formGroupToReturn = undefined;
    if (formGroup) {
      if (formGroup.controls && Object.keys(formGroup.controls).includes('val')) {
        // Chercher par inputId value
        if (fieldId === formGroup.controls['inputId']?.value) {
          formGroupToReturn = formGroup;
        }
        // Si pas trouvé, chercher dans idInput du control val (format: "prefix|fieldId")
        if (!formGroupToReturn && formGroup.controls['val']?.idInput) {
          const idInputParts = formGroup.controls['val'].idInput.split('|');
          const fieldIdFromIdInput = idInputParts.length > 1 ? idInputParts[1] : idInputParts[0];
          if (fieldId === fieldIdFromIdInput) {
            formGroupToReturn = formGroup;
          }
        }
      } else if (formGroup.controls && Array.isArray(formGroup.controls)) {
        formGroup.controls.forEach(item => {
          let returnValue = this.findInputForm(fieldId, item);
          if (returnValue) {
            formGroupToReturn = returnValue;
          }
        });
      } else if (formGroup.controls) {
        Object.keys(formGroup.controls).forEach((key: string) => {
          let returnValue = this.findInputForm(fieldId, formGroup.controls[key]);
          if (returnValue) {
            formGroupToReturn = returnValue;
          }
        });
      }
    }
    return formGroupToReturn;
  }

  private surchargeMessage(name, location, message) {
    if (name === 'E_FORM_17' && location === "$.ContractNotice.ProcurementProjectLot.TenderingTerms.TendererQualificationRequest[0]") {
      return "rule|text|BR-BT-00761-0023";
    }
    if (name === 'E_FORM_18' && location === "$.ContractNotice.ProcurementProjectLot.TenderingTerms.TendererQualificationRequest[0]") {
      return "rule|text|BR-BT-00761-0024";
    }

    // Rediriger les erreurs de nœud ND-ProcedureTenderingProcess vers le champ BT-105-Procedure
    // Quand le nœud parent TenderingProcess est absent, le schematron remonte une erreur au niveau du nœud
    // au lieu du champ BT-105. On redirige vers le message propre au champ BT-105.
    const ndProcedureTenderingProcessMapping = {
      'E_FORM_10': 'rule|text|BR-BT-00105-0015',
      'E_FORM_11': 'rule|text|BR-BT-00105-0016',
      'E_FORM_12': 'rule|text|BR-BT-00105-0016',
      'E_FORM_13': 'rule|text|BR-BT-00105-0016',
      'E_FORM_16': 'rule|text|BR-BT-00105-0022',
      'E_FORM_17': 'rule|text|BR-BT-00105-0023',
      'E_FORM_18': 'rule|text|BR-BT-00105-0024',
      'E_FORM_20': 'rule|text|BR-BT-00105-0022',
      'E_FORM_21': 'rule|text|BR-BT-00105-0022',
      'E_FORM_22': 'rule|text|BR-BT-00105-0022',
      'E_FORM_23': 'rule|text|BR-BT-00105-0030',
      'E_FORM_24': 'rule|text|BR-BT-00105-0031',
      'E_FORM_25': 'rule|text|BR-BT-00105-0032',
      'E_FORM_26': 'rule|text|BR-BT-00105-0033',
      'E_FORM_27': 'rule|text|BR-BT-00105-0034',
      'E_FORM_28': 'rule|text|BR-BT-00105-0035',
      'E_FORM_29': 'rule|text|BR-BT-00105-0036',
      'E_FORM_30': 'rule|text|BR-BT-00105-0037',
      'E_FORM_31': 'rule|text|BR-BT-00105-0038',
    };
    if (message.startsWith('rule|text|ND-ProcedureTenderingProcess-') && ndProcedureTenderingProcessMapping[name]) {
      return ndProcedureTenderingProcessMapping[name];
    }

    // Rediriger les erreurs de nœud ND-PostAwardProcess vers le champ BT-92-Lot
    const ndPostAwardProcessMapping = {
      'E_FORM_16': 'rule|text|BR-BT-00092-0022',
    };
    if (message.startsWith('rule|text|ND-PostAwardProcess-') && ndPostAwardProcessMapping[name]) {
      return ndPostAwardProcessMapping[name];
    }

    // Rediriger les erreurs de nœud ND-LotProcurementDocument vers le champ BT-14-Lot
    const ndLotProcurementDocumentMapping = {
      'E_FORM_16': 'rule|text|BR-BT-00014-0073',
      'E_FORM_17': 'rule|text|BR-BT-00014-0074',
      'E_FORM_19': 'rule|text|BR-BT-00014-0076',
      'E_FORM_23': 'rule|text|BR-BT-00014-0081',
      'E_FORM_24': 'rule|text|BR-BT-00014-0082',
    };
    if (message.startsWith('rule|text|ND-LotProcurementDocument-') && ndLotProcurementDocumentMapping[name]) {
      return ndLotProcurementDocumentMapping[name];
    }

    // Rediriger les erreurs de nœud ND-AuctionTerms vers le champ BT-767-Lot
    const ndAuctionTermsMapping = {
      'E_FORM_16': 'rule|text|BR-BT-00767-0022',
      'E_FORM_17': 'rule|text|BR-BT-00767-0023',
      'E_FORM_18': 'rule|text|BR-BT-00767-0024',
      'E_FORM_22': 'rule|text|BR-BT-00767-0029',
      'E_FORM_29': 'rule|text|BR-BT-00767-0036',
    };
    if (message.startsWith('rule|text|ND-AuctionTerms-') && ndAuctionTermsMapping[name]) {
      return ndAuctionTermsMapping[name];
    }

    // Rediriger les erreurs de nœud ND-LotProcurementScope vers le champ BT-21-Lot
    // On ne fait pas d'expansion multi-champs pour les nœuds lot-level afin d'éviter les doublons inter-lots.
    // Les autres champs (BT-23, BT-24, BT-262) apparaîtront via le stage 2a une fois le nœud créé.
    const ndLotProcurementScopeMapping = {
      'E_FORM_14': 'rule|text|BR-BT-00021-0176',
      'E_FORM_16': 'rule|text|BR-BT-00021-0178',
      'E_FORM_17': 'rule|text|BR-BT-00021-0179',
      'E_FORM_18': 'rule|text|BR-BT-00021-0180',
      'E_FORM_19': 'rule|text|BR-BT-00021-0181',
      'E_FORM_20': 'rule|text|BR-BT-00021-0183',
      'E_FORM_21': 'rule|text|BR-BT-00021-0184',
      'E_FORM_22': 'rule|text|BR-BT-00021-0185',
      'E_FORM_23': 'rule|text|BR-BT-00021-0186',
      'E_FORM_24': 'rule|text|BR-BT-00021-0187',
      'E_FORM_25': 'rule|text|BR-BT-00021-0188',
      'E_FORM_26': 'rule|text|BR-BT-00021-0189',
      'E_FORM_27': 'rule|text|BR-BT-00021-0190',
      'E_FORM_28': 'rule|text|BR-BT-00021-0191',
      'E_FORM_29': 'rule|text|BR-BT-00021-0192',
    };
    if (message.startsWith('rule|text|ND-LotProcurementScope-') && ndLotProcurementScopeMapping[name]) {
      return ndLotProcurementScopeMapping[name];
    }

    // Rediriger les erreurs de nœud ND-AwardingTerms vers le champ principal des conditions d'attribution
    const ndAwardingTermsMapping = {
      'E_FORM_23': 'rule|text|BR-BT-00041-0030',
      'E_FORM_24': 'rule|text|BR-BT-00041-0031',
      'E_FORM_29': 'rule|text|BR-BT-00539-0190',
      'E_FORM_31': 'rule|text|BR-BT-00539-0192',
      'E_FORM_32': 'rule|text|BR-BT-00539-0193',
    };
    if (message.startsWith('rule|text|ND-AwardingTerms-') && ndAwardingTermsMapping[name]) {
      return ndAwardingTermsMapping[name];
    }

    // Rediriger les erreurs de nœud ND-PartProcurementScope vers le champ BT-21-Part
    const ndPartProcurementScopeMapping = {
      'E_FORM_4': 'rule|text|BR-BT-00021-0059',
      'E_FORM_5': 'rule|text|BR-BT-00021-0060',
      'E_FORM_6': 'rule|text|BR-BT-00021-0061',
      'E_FORM_E2': 'rule|text|BR-BT-00021-0062',
    };
    if (message.startsWith('rule|text|ND-PartProcurementScope-') && ndPartProcurementScopeMapping[name]) {
      return ndPartProcurementScopeMapping[name];
    }

    // Rediriger les erreurs de nœud ND-PartTenderingTerms vers le champ BT-21-Part (pas de champ direct)
    const ndPartTenderingTermsMapping = {
      'E_FORM_4': 'rule|text|BR-BT-00021-0059',
      'E_FORM_5': 'rule|text|BR-BT-00021-0060',
      'E_FORM_6': 'rule|text|BR-BT-00021-0061',
    };
    if (message.startsWith('rule|text|ND-PartTenderingTerms-') && ndPartTenderingTermsMapping[name]) {
      return ndPartTenderingTermsMapping[name];
    }

    // Rediriger les erreurs de nœud ND-LotTenderingProcess vers le champ BT-17-Lot
    const ndLotTenderingProcessMapping = {
      'E_FORM_10': 'rule|text|BR-BT-00017-0015',
      'E_FORM_11': 'rule|text|BR-BT-00017-0016',
      'E_FORM_16': 'rule|text|BR-BT-00017-0022',
      'E_FORM_17': 'rule|text|BR-BT-00017-0023',
    };
    if (message.startsWith('rule|text|ND-LotTenderingProcess-') && ndLotTenderingProcessMapping[name]) {
      return ndLotTenderingProcessMapping[name];
    }

    // Rediriger les erreurs de nœud ND-LotTenderingTerms vers le champ BT-60-Lot
    const ndLotTenderingTermsMapping = {
      'E_FORM_16': 'rule|text|BR-BT-00060-0022',
      'E_FORM_19': 'rule|text|BR-BT-00060-0025',
      'E_FORM_29': 'rule|text|BR-BT-00060-0036',
      'E_FORM_32': 'rule|text|BR-BT-00060-0039',
    };
    if (message.startsWith('rule|text|ND-LotTenderingTerms-') && ndLotTenderingTermsMapping[name]) {
      return ndLotTenderingTermsMapping[name];
    }

    // Rediriger les erreurs de nœud ND-PaymentTerms vers le champ BT-77-Lot
    const ndPaymentTermsMapping = {
      'E_FORM_17': 'rule|text|BR-BT-00077-0023',
      'E_FORM_18': 'rule|text|BR-BT-00077-0024',
      'E_FORM_22': 'rule|text|BR-BT-00077-0029',
    };
    if (message.startsWith('rule|text|ND-PaymentTerms-') && ndPaymentTermsMapping[name]) {
      return ndPaymentTermsMapping[name];
    }

    // Rediriger les erreurs de nœud ND-OptionsAndRenewals vers le champ BT-58-Lot
    const ndOptionsAndRenewalsMapping = {
      'E_FORM_15': 'rule|text|BR-BT-00058-0021',
      'E_FORM_17': 'rule|text|BR-BT-00058-0023',
      'E_FORM_18': 'rule|text|BR-BT-00058-0024',
    };
    if (message.startsWith('rule|text|ND-OptionsAndRenewals-') && ndOptionsAndRenewalsMapping[name]) {
      return ndOptionsAndRenewalsMapping[name];
    }

    // Rediriger les erreurs de nœud ND-LotEmploymentLegislation/Environmental/Fiscal
    if (message.startsWith('rule|text|ND-LotEmploymentLegislation-') && name === 'E_FORM_9') {
      return 'rule|text|BR-OPT-00113-0065';
    }
    if (message.startsWith('rule|text|ND-LotEnvironmentalLegislation-') && name === 'E_FORM_9') {
      return 'rule|text|BR-OPT-00112-0065';
    }
    if (message.startsWith('rule|text|ND-LotFiscalLegislation-') && name === 'E_FORM_9') {
      return 'rule|text|BR-OPT-00111-0065';
    }

    // Rediriger les erreurs de nœud ND-LotTenderingProcessExtension vers BT-630(d)-Lot
    const ndLotTenderingProcessExtMapping = {
      'E_FORM_10': 'rule|text|BR-BT-00630-0015',
      'E_FORM_11': 'rule|text|BR-BT-00630-0016',
      'E_FORM_12': 'rule|text|BR-BT-00630-0018',
      'E_FORM_13': 'rule|text|BR-BT-00630-0019',
      'E_FORM_14': 'rule|text|BR-BT-00630-0020',
      'E_FORM_CEI': 'rule|text|BR-BT-00630-0017',
      'E_FORM_E1': 'rule|text|BR-BT-00800-0003',
    };
    if (message.startsWith('rule|text|ND-LotTenderingProcessExtension-') && ndLotTenderingProcessExtMapping[name]) {
      return ndLotTenderingProcessExtMapping[name];
    }

    // Rediriger les erreurs de nœud ND-InterestExpressionReceptionPeriod vers BT-630(d)-Lot
    const ndInterestExpressionMapping = {
      'E_FORM_10': 'rule|text|BR-BT-00630-0015',
      'E_FORM_11': 'rule|text|BR-BT-00630-0016',
      'E_FORM_12': 'rule|text|BR-BT-00630-0018',
      'E_FORM_13': 'rule|text|BR-BT-00630-0019',
      'E_FORM_14': 'rule|text|BR-BT-00630-0020',
      'E_FORM_CEI': 'rule|text|BR-BT-00630-0017',
    };
    if (message.startsWith('rule|text|ND-InterestExpressionReceptionPeriod-') && ndInterestExpressionMapping[name]) {
      return ndInterestExpressionMapping[name];
    }

    // Rediriger les erreurs de nœud ND-Part vers BT-137-Part
    const ndPartMapping = {
      'E_FORM_4': 'rule|text|BR-BT-00137-0007',
      'E_FORM_5': 'rule|text|BR-BT-00137-0008',
      'E_FORM_6': 'rule|text|BR-BT-00137-0009',
      'E_FORM_E2': 'rule|text|BR-BT-00137-0010',
    };
    if (message.startsWith('rule|text|ND-Part-') && ndPartMapping[name]) {
      return ndPartMapping[name];
    }

    // Rediriger les erreurs de nœud ND-LotDuration vers BT-781-Lot
    if (message.startsWith('rule|text|ND-LotDuration-') && name === 'E_FORM_E5') {
      return 'rule|text|BR-BT-00781-0050';
    }

    // Rediriger les erreurs de nœud ND-PMCAnswersDeadline vers BT-800(d)-Lot
    if (message.startsWith('rule|text|ND-PMCAnswersDeadline-') && name === 'E_FORM_E1') {
      return 'rule|text|BR-BT-00800-0003';
    }

    // Rediriger les erreurs de nœud ND-ContractModification vers BT-1501(n)-Contract
    const ndContractModificationMapping = {
      'E_FORM_38': 'rule|text|BR-BT-01501-0047',
      'E_FORM_39': 'rule|text|BR-BT-01501-0048',
      'E_FORM_40': 'rule|text|BR-BT-01501-0049',
      'E_FORM_E6': 'rule|text|BR-BT-01501-0051',
    };
    if (message.startsWith('rule|text|ND-ContractModification-') && ndContractModificationMapping[name]) {
      return ndContractModificationMapping[name];
    }

    // Rediriger les erreurs de nœud ND-NonUBLTenderingTerms vers BT-651-Lot
    if (message.startsWith('rule|text|ND-NonUBLTenderingTerms-') && name === 'E_FORM_18') {
      return 'rule|text|BR-BT-00651-0024';
    }

    return message;
  }

  private postExportAvis(avis: Avis): Observable<Blob> {
    return this.http.postBlob('/avis/export', avis, null, {httpResponseType: 'blob'});
  }

  public exportXmlAvis(avis: Avis) {
    this.postExportAvis(avis).subscribe({
      next: (data => {
        let blob = new Blob([data], {type: "text/csv"});
        let url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.download = "EXPORT_XML_" + moment().format('YYYYMMDD_HHmmss') + ".xml";
        anchor.href = url;
        anchor.click();
      })
    })
  }

  public exportXmlEform(avis: Avis) {
    this.postExportEform(avis).subscribe({
      next: (data => {
        let blob = new Blob([data], {type: "text/csv"});
        let url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.download = "EXPORT_XML_EFORM_" + moment().format('YYYYMMDD_HHmmss') + ".xml";
        anchor.href = url;
        anchor.click();
      })
    })
  }

  private postExportEform(jsonSaisieFormulaire): Observable<Blob> {
    return this.http.postBlob('/schematron/export', jsonSaisieFormulaire, null, {httpResponseType: 'blob'});
  }

  private findFormControl(path: string, form: any, isIntoDuplicableObject: boolean) {
    // Vérifier si le formulaire existe
    if (!form) {
      return null;
    }

    let tempForm = form;
    let pathElements = path.split('.');
    let stayToRead = path.split('.');
    let i = 1;
    while (i < pathElements.length) {
      let tempSplit = pathElements[i].includes('[') ? pathElements[i].split('[') : '';
      tempForm = tempForm?.controls[tempSplit === '' ? pathElements[i].toLowerCase() : tempSplit[0].toLowerCase()];
      stayToRead.shift();
      if (Array.isArray(tempForm?.controls) && tempSplit === '') {
        if (stayToRead.toString().includes('[')) {
          tempForm = tempForm.controls[0];
        } else {
          break;
        }
      } else if (Array.isArray(tempForm?.controls) && tempSplit !== '') {
        tempForm = this.findCorrectObjetInArray(tempForm, tempSplit, isIntoDuplicableObject);
      }
      i++;
    }

    return tempForm;
  }

  private findCorrectObjetInArray(tempForm, tempSplit, isIntoDuplicableObject): any {
    let elementIndex = tempSplit[1].replace('[', '').replace(']', '');

    const enumKeys = Object.values(DuplicableObjectArrayEnum)
      .filter((v): v is string => typeof v === "string")
      .map(v => v.toLowerCase());

    //Dans le cas d'un objet duplicable, un seul objet est chargé à la fois pour des raisons de performance donc on regarde toujours dans le premier.
    if (isIntoDuplicableObject && enumKeys.includes(tempSplit[0].toLowerCase())) {
      tempForm = tempForm.controls[0];
    } else {
      // Vérifier si l'élément existe à l'index spécifié, sinon prendre le premier
      if (tempForm.controls && tempForm.controls[elementIndex] != null) {
        tempForm = tempForm.controls[elementIndex];
      } else if (tempForm.controls && tempForm.controls[0] != null) {
        tempForm = tempForm.controls[0];
      } else {
        tempForm = null;
      }
    }
    return tempForm;
  }


  public mapErrorToMessage(error, ctrl, specificMessaged): string {
    if (error === 'required') {
      let key = '';
      if (specificMessaged?.required) {
        key = 'error.' + specificMessaged.required;
      } else {
        key = 'error.required';
      }
      return this.translate.instant(key);
    }
    if (error === 'email') {
      let key = '';
      if (specificMessaged?.email) {
        key = 'error.' + specificMessaged.email;
      } else {
        key = 'error.email';
      }
      return this.translate.instant(key, {
        value: ctrl.errors?.pattern.actualValue,
        pattern: ctrl.errors?.pattern.requiredPattern
      });
    }
    if (error === 'pattern') {
      let key = '';
      if (specificMessaged?.pattern) {
        key = 'error.' + specificMessaged.pattern;
      } else {
        key = 'error.pattern';
      }
      return this.translate.instant(key, {
        value: ctrl.errors?.pattern.actualValue,
        pattern: ctrl.errors?.pattern.requiredPattern
      });
    }
    if (error === 'invalidReferenceValue') {
      let key = '';
      if (specificMessaged?.invalidReferenceValue) {
        key = 'error.' + specificMessaged.invalidReferenceValue;
      } else {
        key = 'error.invalid_reference_value';
      }
      return this.translate.instant(key);
    }
    if (error === 'min') {
      let key = '';
      if (specificMessaged?.min) {
        key = 'error.' + specificMessaged.min;
      } else {
        key = 'error.min';
      }
      return this.translate.instant(key, {value: ctrl.errors?.min.min});
    }
    if (error === 'max') {
      let key = '';
      if (specificMessaged?.max) {
        key = 'error.' + specificMessaged.max;
      } else {
        key = 'error.max';
      }
      return this.translate.instant(key, {value: ctrl.errors?.max.max});
    }
    if (error === 'minlength') {
      let key = '';
      if (specificMessaged?.minLength) {
        key = 'error.' + specificMessaged.minLength;
      } else {
        key = 'error.min_caractere';
      }
      return this.translate.instant(key, {value: ctrl.errors?.minlength.requiredLength});
    }
    if (error === 'maxlength') {
      let key = '';
      if (specificMessaged?.maxLength) {
        key = 'error.' + specificMessaged.maxLength;
      } else {
        key = 'error.max_caractere';
      }
      return this.translate.instant(key, {value: ctrl.errors?.maxlength.requiredLength});
    }
    if (error === 'minCaractere') {
      let key = '';
      if (specificMessaged?.minCaractere) {
        key = 'error.' + specificMessaged.minCaractere;
      } else {
        key = 'error.min_caractere';
      }
      return this.translate.instant(key, {value: ctrl.errors?.minCaractere.requiredLength});
    }
    if (error === 'maxCaractere') {
      let key = '';
      if (specificMessaged?.maxCaractere) {
        key = 'error.' + specificMessaged.maxCaractere;
      } else {
        key = 'error.max_caractere';
      }
      return this.translate.instant(key, {value: ctrl.errors?.maxCaractere.requiredLength});
    }
    /*PRB0053517 : traduction du code d'erreur en message compréhensible */
    if (error === 'minTextLength') {
      let key = '';
      if (specificMessaged?.minTextLength) {
        key = 'error.' + specificMessaged.minTextLength;
      } else {
        key = 'error.min_text_length';
      }
      return this.translate.instant(key, {value: ctrl.errors?.minTextLength.requiredLength});
    }

    return ctrl.errors ? '[A_TRAITER] : ' + JSON.stringify(ctrl.errors) : '';
  }


  public validate(avis: Avis): Observable<any> {
    return this.http.post(Endpoints.AVIS_VALIDATE, avis);
  }


  public extractAvis(form, avisId, referenceAvis, critereId, stepId, actualPageIndex, flux, stepValue = null, onModification = true, refAvisLie = null): Avis {
    if (this.stepperBuilderService.formulaire == null) {
      return null;
    }
    // chercher l'extracteur du formulaire
    const formulaireExtractor = this.formulaireExtractorDispatcherService.getExtractor(this.stepperBuilderService.formulaire);
    // extraire le formulaire adapté
    const partieAD = this.formADExtractorService.mapFormToAvis(form, this.actualFormIdAnnEmetteur.getValue())?.jsonSaisieFormulaire.ann.formAD;
    // extraire l'avis (combiner l'extracteur du formulaire et l'extracteur commun)
    // *********************/
    const avis: Avis = formulaireExtractor.mapFormToAvis(form, actualPageIndex, this.actualFormIdAnnEmetteur.getValue());
    // *********************/
    avis.jsonSaisieFormulaire.ann.formAD = partieAD;
    avis.avisId = avisId;
    if (flux && flux.length > 0) {
      avis.flux = flux;
    }
    avis.reference = referenceAvis;
    avis.critere.id = critereId;
    avis.critere.formulaires = [];
    avis.user = this.session.getUser();
    avis.refAvisLie = refAvisLie;
    const diffFormGrp: any = form.get(Constants.TABLE_DATA_CTRL_NAME);
    const diffsCtrl: any = diffFormGrp.controls;
    const selectedDiffuseur = [];
    Object.keys(diffsCtrl).forEach((key) => {
      if (!key.includes('p')) {
        const idDiff = +key;
        const isChecked = diffsCtrl[key].controls.checked.value;
        this.LOG.debug('[DIFF]', idDiff, diffsCtrl[key].controls.diffuseur.value, isChecked);
        if (isChecked) {
          if (!onModification) {
            const flux: Flux = new Flux();
            flux.id.diffuseurId = idDiff;
            flux.id.avisId = avisId;
            flux.annonceur = null;
            flux.statut = StatutFluxEnum.EN_ATTENTE;
            avis.flux.push(flux);
          }
          selectedDiffuseur.push(diffsCtrl[key].controls.zonediffusion.value);
        }
      }
    });
    avis.jsonSaisieFormulaire.isBOAMPorJOUE = selectedDiffuseur.includes('NATIONAL') || selectedDiffuseur.includes('EUROPE');
    avis.jsonSaisieFormulaire.isSHALorPS = selectedDiffuseur.filter(f => f !== 'EUROPE' && f !== 'NATIONAL').length > 0 || false;

    // ✅ FIX 2026-03-02: Encoder stepId et stepSubSection dans un seul champ
    // Format: stepId * 100 + stepSubSection (ex: 4.2 -> 402, 3.1 -> 301, 5 -> 500)
    const stepIdStr = stepId?.toString() || '0';
    if (stepIdStr.includes('.')) {
      const parts = stepIdStr.split('.');
      const mainStep = Number(parts[0]);
      const subSection = Number(parts[1]);
      avis.jsonSaisieFormulaire.stepId = mainStep * 100 + subSection;
    } else {
      const mainStep = Number(stepIdStr);
      avis.jsonSaisieFormulaire.stepId = mainStep * 100;
    }

    // ✅ FIX 2026-03-02: Sauvegarder stepValue dans le champ version au format "SV:X"
    if (stepValue !== null && stepValue !== undefined) {
      avis.jsonSaisieFormulaire.version = 'SV:' + stepValue;
      // ✅ FIX 2026-04-03: Corriger l'ID du lot avec stepValue fiable.
      // stepValue vient UNIQUEMENT de la page SOURCE (jamais de la destination, fix 2026-04-24).
      // Surcharge fixCurrentLotId() de mapFormToAvis() qui utilise actuallyIndexLotOrPar.
      this.eformsExtractorService.fixCurrentLotId(avis.jsonSaisieFormulaire, stepValue);
    } else {
      if (avis.jsonSaisieFormulaire.version?.startsWith('SV:')) {
        avis.jsonSaisieFormulaire.version = null;
      }
    }

    avis.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos = this.avisDataTransferService.sourceAppProfilAcheteurInfos;

    // ✅ FIX 2026-04-14: Propager prefillValues dans chaque sauvegarde
    // prefillValues est peuplé lors du prefillEforms et doit être persisté en base
    // pour être disponible lors des chargements suivants (form-input le lit depuis l'avis chargé)
    if (this.avisDataTransferService.avis?.jsonSaisieFormulaire?.prefillValues) {
      avis.jsonSaisieFormulaire.prefillValues = this.avisDataTransferService.avis.jsonSaisieFormulaire.prefillValues;
    }

    // Priorité: sourceAppProfilAcheteurInfos.refConsultation > avisDataTransferService.refConsultation > sessionStorage
    // Fix: utiliser la référence de consultation de sourceAppProfilAcheteurInfos en priorité (cas décrochage vers une autre consultation)
    if (this.avisDataTransferService.sourceAppProfilAcheteurInfos?.refConsultation &&
      this.avisDataTransferService.sourceAppProfilAcheteurInfos.refConsultation.toString().trim() !== '') {
      avis.refConsultation = this.avisDataTransferService.sourceAppProfilAcheteurInfos.refConsultation.toString();
    } else if (this.avisDataTransferService.refConsultation && this.avisDataTransferService.refConsultation.trim() !== '') {
      avis.refConsultation = this.avisDataTransferService.refConsultation;
    } else {
      const refConsultationSession = sessionStorage.getItem('referenceConsultation');
      avis.refConsultation = refConsultationSession && refConsultationSession.trim() !== '' ? refConsultationSession : undefined;
    }
    return avis;
  }

  hasTranslation(JsonPath) {
    return this.translate.instant(JsonPath) !== JsonPath;
  }

  getJSON(form: FormGroup, step, contenuPdf) {
    let json;
    const temp = [];
    const formStep = 'form-step';
    const formStepFacturation = 'form-step-facturation';
    const formStepIndexation = 'form-step-indexation';
    const formStepAnnonceur = 'form-step-annonceur'; //PRB0053741
    let int_map = new Map<string, { libelle: string, displayed: boolean, index: number }>();
    let int_map_ss = new Map<string, { libelle: string, displayed: boolean, code: string }>();
    let text_prefix = new Map<string, string>();
    let legend_prefix = new Map<string, string>();
    let indexStep: number = 0;

    document.getElementById('left-menu-stepper')?.querySelectorAll(':scope span.EtapeStepper-Texte')?.forEach((span: any) => {
      const stepId = span.dataset.stepid ? span.dataset.stepid : span.dataset.name.split('|').pop();
      int_map.set(stepId, {libelle: span.dataset.name, displayed: false, index: indexStep});
      text_prefix.set(span.dataset.code, stepId);
      legend_prefix.set((legend_prefix.size + 1) + '', stepId);
      indexStep++;
    });
    if (form.value?.eforms) {
      json = {formulaire: {}};
      document.getElementById('left-menu-stepper')?.querySelectorAll(':scope span.ss-etp-texte')?.forEach((span: any) => {
        const stepId = span.dataset.stepid ? span.dataset.stepid : span.dataset.name.split('|').pop();
        int_map_ss.set(stepId, {libelle: span.dataset.name, code: span.dataset.code, displayed: false});
      });
      document.getElementById('form-step')?.querySelectorAll('input, select, mat-radio-button')?.forEach((data: any, i) => {
        if (data.label && data.section) {
          let sectionSansSuffixe = this.removeSuffix(data.section);
          if (json.formulaire[sectionSansSuffixe] == undefined) {
            json.formulaire[sectionSansSuffixe] = [];
          }
          if (int_map.get(sectionSansSuffixe) && !int_map.get(sectionSansSuffixe)?.displayed) {
            int_map.set(sectionSansSuffixe, {
              libelle: int_map.get(sectionSansSuffixe)?.libelle,
              displayed: true,
              index: int_map.get(sectionSansSuffixe)?.index
            });
            json.formulaire[sectionSansSuffixe].push({
              ordre: 0, // Les titres doivent toujours être en premier
              label: int_map.get(sectionSansSuffixe)?.index + '. ' + this.translate.instant(int_map.get(sectionSansSuffixe)?.libelle),
              xpath: null,
              value: null,
              type: 'titre'
            });
          }
          if (int_map_ss.get(data.subSectionId) && !int_map_ss.get(data.subSectionId)?.displayed) {
            int_map_ss.set(data.subSectionId, {
              libelle: int_map_ss.get(data.subSectionId)?.libelle,
              displayed: true,
              code: int_map_ss.get(data.subSectionId)?.code
            });
            json.formulaire[sectionSansSuffixe].push({
              ordre: 0, // Les sous-titres doivent aussi être en premier
              label: int_map_ss.get(data.subSectionId)?.code + '. ' + this.translate.instant(int_map_ss.get(data.subSectionId)?.libelle),
              xpath: null,
              value: null,
              type: 'soustitre'
            });
          }
          if (data.localName === 'mat-radio-button') {
            if (data.className?.includes('mat-radio-checked')) {
              json.formulaire[sectionSansSuffixe].push({
                ordre: json.formulaire[sectionSansSuffixe].length,
                label: data.label + " (" + data.fieldId + ")",
                xpath: null,
                value: data.outerText,
                type: data.localName
              });
            }
          }
          if (data.localName === 'select') {
            if (data.selectedOptions[0]?.label && data.selectedOptions[0]?.label !== '- Sélectionner -') {
              json.formulaire[sectionSansSuffixe].push({
                ordre: json.formulaire[sectionSansSuffixe].length,
                label: data.label + " (" + data.fieldId + ")",
                xpath: null,
                value: data.selectedOptions[0]?.label,
                type: data.localName
              });
            }
          } else {
            if (data.value) {
              json.formulaire[sectionSansSuffixe].push({
                ordre: json.formulaire[sectionSansSuffixe].length,
                label: data.label + " (" + data.fieldId + ")",
                xpath: null,
                value: data.value,
                type: data.localName
              });
            }
          }
        }
      });
      json.formulaire['_STEP_ID_SepSep_TypeFacturation'] = [];
      json.formulaire['_STEP_ID_SepSep_TypeIndexation'] = [];
      json.formulaire['_STEP_ID_SepSep_idAnnonceur'] = [];//PRB0053741
    } else {
      json = {formulaire: contenuPdf.champs};
      // Réinitialiser les champs du step courant (en gardant le titre) avant
      // ré-extraction depuis le DOM. Sans cela, les champs dont la visibilité a
      // changé (ex: adresse France → étranger) restent fantômes et apparaissent
      // en doublon dans le PDF.
      const currentStepKey = Number.isNaN(+step) ? step : '_STEP_ID_' + step;
      if (json.formulaire && json.formulaire[currentStepKey]) {
        const titleEntry = json.formulaire[currentStepKey].find(f => f.type === 'titre');
        json.formulaire[currentStepKey] = titleEntry ? [titleEntry] : [];
      }
      this.extractField(formStep, text_prefix, legend_prefix, int_map, json, form, temp, step);
    }
    // Reset + ré-extraction conditionnés à la présence du fieldset dans le DOM : json.formulaire
    // est contenuPdf.champs par référence, et *ngIf="facturationDila"/"indexation" retire le
    // fieldset quand la section n'a pas encore de données. Un reset inconditionnel effacerait
    // alors définitivement la section au lieu de la laisser simplement obsolète.
    [
      {id: formStepFacturation, key: '_STEP_ID_SepSep_TypeFacturation'},
      {id: formStepIndexation, key: '_STEP_ID_SepSep_TypeIndexation'},
      //PRB0053741: ajout de formStepAnnonceur
      {id: formStepAnnonceur, key : '_STEP_ID_SepSep_idAnnonceur'}
    ].forEach(({id, key}) => {
      const fieldset = document.getElementById(id);
      if (!fieldset) {
        return;
      }
      if (json.formulaire && json.formulaire[key]) {
        json.formulaire[key] = [];
      }
      this.extractField(fieldset, text_prefix, legend_prefix, int_map, json, form, [], key);
    });
    return JSON.parse(JSON.stringify(json), (key, value) => value === null || value === '' ? undefined : value);
  }

  /**
   *
   * @param str supression de "_0" à la fin des string
   * @returns
   */
  removeSuffix(str) {
    if (str.endsWith('_0')) {
      return str.slice(0, -2);
    }
    return str;
  }

  /**
   * récupération des champs avis nationaux
   * @param formStep
   * @param text_prefix
   * @param legend_prefix
   * @param int_map
   * @param json
   * @param form
   * @param temp
   */
  private extractField(
    formStep: string | HTMLElement, text_prefix: Map<string, string>,
    legend_prefix: Map<string, string>, int_map: Map<string, { libelle: string; displayed: boolean; index: number; }>,
    json: { formulaire: Map<string, Array<Champ>> }, form: FormGroup,
    temp: any[], step
  ) {
    const root = typeof formStep === 'string' ? document.getElementById(formStep) : formStep;
    root?.querySelectorAll('span[hidden], legend, fieldset')?.forEach((data: any, i) => {
      let label = null;
      let value = null;
      let type = 'text';
      let xpath = null;
      let thisStep = Number.isNaN(+step) ? step : "_STEP_ID_" + step;
      let prefix = '';
      if (data.tagName.toLowerCase() == 'legend' || data.tagName.toLowerCase() == 'fieldset') {
        if (data.id.includes('.')) {
          prefix = text_prefix.get(data.id.split('.')[0].replace('step', '').replace('span', ''));
        } else {
          prefix = legend_prefix.get(data.id.split('_')[0].replace('step', '').replace('span', ''));
        }
      } else if (data.id.match(/_((COMMON)|(STEP))_ID_\d+/gmi)) {
        prefix = data.id.match(/_((COMMON)|(STEP))_ID_\d+/gmi)[0];
      } else if (data.id.match(/_((SepSep_TypeIndexation)|(SepSep_TypeFacturation)|(SepSep_formAd)|(SepSep_idAnnonceur))_+/gmi)) {
        //PRB0053741: ajout de SepSep_idAnnonceur
        prefix = data.id.match(/_((SepSep_TypeIndexation)|(SepSep_TypeFacturation)|(SepSep_formAd)|(SepSep_idAnnonceur))_+/gmi)[0];
      } else {
        return;
      }
      if (prefix && int_map.get(prefix) && !int_map.get(prefix)?.displayed) {
        int_map.set(prefix, {
          libelle: int_map.get(prefix)?.libelle,
          displayed: true,
          index: int_map.get(data.section)?.index
        });
        //json.formulaire[thisStep].push({ ordre: json.formulaire[thisStep].length + temp.length, label: this.translate.instant(int_map.get(prefix)?.libelle), xPath: xpath, value: null, type: 'titre' });
      }

      if (data.tagName.toLowerCase() == 'legend') {
        // Ignorer les éléments d'icône/action connus (ex. "titre-facturation" contient désormais
        // un bouton étoile de préférence avec mat-icon, dont le texte "star_border" - ligature de
        // l'icône - se retrouverait sinon concaténé via textContent) : on retire une copie de ces
        // éléments précis avant de lire le texte restant, quelle que soit leur position parmi les
        // nœuds enfants. Plus robuste que ne cibler que le 1er nœud texte direct, qui peut être
        // vide selon le moment où le DOM est scanné. Ciblage volontairement restreint (pas
        // `querySelectorAll('*')`) pour ne pas avaler silencieusement un futur balisage inline
        // légitime dans une legend (ex. <legend>Montant <strong>HT</strong></legend>).
        const legendClone = data.cloneNode(true) as HTMLElement;
        legendClone.querySelectorAll('mat-icon, button, app-star-preference').forEach((el: Element) => el.remove());
        label = legendClone.textContent?.trim();
        type = 'legend';
      } else {
        label = data.textContent ? data.textContent : data.getAttribute('for');
        xpath = data.id.replace('span', '');
        value = form.controls[xpath]?.value;


        switch (data.className) {
          case 'radio':
            type = 'radio';
            if (this.caseRadio(data, value))
              value = this.translate.instant(this.caseRadio(data, value));
            break;
          case 'checkbox':
            type = 'checkbox';
            break;
          case 'date':
          case 'datetime':
            type = 'date';
            if (!value || value == 'yyyy-MM-dd') {
              value = null;
            }
            break;
          case 'select':
            type = 'liste';
            value = this.caseSelect(data, value);
            break;
          case 'chips':
            type = 'chips';
            value = this.caseChips(data, value);
            break;
          case 'fieldset':
            break;
        }
        if (data.className.startsWith('ng-tns') && !data.className.includes('autocomplete')) {
          value = null;
        }
        if (data.className.startsWith('span')) {
          type = 'span';
        }
      }

      if ((value !== null && value !== undefined && value !== false && (value !== '' || data.className == 'checkbox' || data.className == 'radio' || data.className == 'select')) || (type == 'legend' && prefix)) {
        while (temp.length > 0) {
          let tempShift = temp.shift();
          this.pushOrModifyLine(json, thisStep, tempShift.label ? tempShift.label : '', tempShift.type, tempShift.xpath, tempShift.value, tempShift.ordre);
          //json.formulaire[thisStep].push(temp.shift());
        }
        if (data.className == 'chips') {
          this.pushOrModifyLine(json, thisStep, label ? label : '', type, xpath + '_chips', value, i);
        } else {
          this.pushOrModifyLine(json, thisStep, label ? label : '', type, xpath, value, i);
        }
        //json.formulaire[thisStep].push({ ordre: json.formulaire[thisStep].length, label: label ? label : '', xPath: xpath, value, type });
      } else if ((type == 'legend' || type == 'span')  && label) { // dans le cas où la legend n'est pas annotée, le champ suivant fait foi
        temp.push({ordre: i, label, xpath: null, value: null, type: 'legend'});
      } else if (value == '' || value == null) {
        this.removeLine(json, thisStep, xpath);
      }
      if (value === false && data.className === 'checkbox') {
        this.removeLine(json, thisStep, xpath);
      }

      if ((label && label.trim().toLowerCase() === 'sous-traitance' && value === null) ||
        (label && label.trim().toLowerCase() === 'form.dive_at.getpays' && value === null)) {
        this.removeItem(json, thisStep, label)
      }
    });
  }

  pushOrModifyLine(json, thisStep, label, type, xpath, value, i) {
    //PRB0053741: ajout nouvelle section, car initDefaultFormPDF(path) n'est appelé qu'à l'initialisation d'un nouvel avis
    if (thisStep === '_STEP_ID_SepSep_idAnnonceur' && json && json.formulaire && !json.formulaire[thisStep]) {
      json.formulaire[thisStep] = [];
    }
    if (json != undefined && json.formulaire != undefined && json.formulaire[thisStep] != undefined) {
      // Matching par inclusion volontairement testé dans un seul sens ("nouveau label" ⊂ "label
      // existant") : pour les legends, xpath est toujours null et type toujours 'legend', donc le
      // label est l'unique discriminant entre plusieurs titres de section d'un même step. Le
      // tester dans les deux sens fusionnerait deux titres distincts dès que l'un est une
      // sous-chaîne de l'autre. Le reset de Facturation/Indexation avant ré-extraction dans
      // getJSON couvre déjà le cas de doublon inter-appels que le sens inverse visait à corriger
      // (ce reset est conditionné à la présence du fieldset, mais un doublon ne peut de toute
      // façon naître que d'une extraction, donc d'un fieldset présent).
      const matches = x => (x.label?.includes(label) && x.type?.includes(type) && x.xpath == xpath);
      const existing = json.formulaire[thisStep].find(matches);
      if (!existing) {
        json.formulaire[thisStep].push({ordre: i, label: label ? label : '', xpath: xpath, value, type});
      } else {
        // Rafraîchir aussi le label (pas seulement la value) : sans ça, un label devenu obsolète
        // suite à un changement du DOM (ex: correctif de capture d'une legend) reste figé pour
        // toujours dans contenuPdf.champs, car le filtre de correspondance ci-dessus matche par
        // simple inclusion ("nouveau label" ⊂ "ancien label") sans jamais l'écraser.
        // Un label vide ne doit pas pour autant écraser un label déjà résolu (ex: value présente
        // mais data.getAttribute('for') absent) : on ne remplace que si le nouveau label est non vide.
        existing.value = value;
        if (label) {
          existing.label = label;
        }
      }
    }
  }

  removeLine(json, thisStep, xpath) {
    if (json != undefined && json.formulaire != undefined && json.formulaire[thisStep] != undefined && xpath?.length > 0) {
      const indexToRemove = json.formulaire[thisStep].findIndex(x => x.xpath === xpath);
      if (indexToRemove >= 0) {
        json.formulaire[thisStep].splice(indexToRemove, 1);
      }
    }
  }



  caseRadio(data, value) {
    const getProperties = JSON.parse(data.dataset.radiosfad);
    return getProperties.find(radio => radio.value == value)?.label;
  }

  caseSelect(data, value) {
    if (data.dataset.typeselect != '' && data.dataset.typeselect != null) {
      const getProperties = this.autoCompleteService.getOptions(data.dataset.typeselect).find(select => select.code == value);
      if (getProperties === undefined && data.dataset.typeselect === 'PAYS') {
        // cas pays france
        return null;
      }
      if (getProperties && getProperties.libelle === '- Sélectionner -') {
        // selectionner == null en cas d'un select
        return null;
      }
      return getProperties ? getProperties.libelle : '';
    } else {
      return value;
    }
  }

  /**
   * récupération des valeur de type chips et conversion en chaine de caractére séparé par ";"
   * @param data
   * @param value
   * @returns
   */
  caseChips(data, value) {
    const liste = this.autoCompleteService.getOptions(data.dataset.typechips);
    let myArray = [];
    if (liste && value) {
      value?.forEach(v => {
        const l = liste.find(chips => chips.code === v);
        if (l) {
          myArray.push(l.libelle);
        }
      });
    } else if (value) {
      value?.forEach(v => {
        myArray.push(v);
      });
    }
    return myArray.join('; ');
  }

  removeItem(json, thisStep, label) {
    const indexToRemove = json.formulaire[thisStep].findIndex(x => x.label === label);
    if (indexToRemove >= 0) {
      json.formulaire[thisStep].splice(indexToRemove, 1);
    }
  }
}
